export default "__VITE_ASSET__D0FEy0Ru__"